import React, { Fragment } from 'react';
import Panel from '../../../../../components/outline/Panel';
import SelectForm from '../../../../../components/form/SelectForm';
import BaseForm from '../../../../../components/form/BaseForm';
import { setDash } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import {
  ACCOUNT_SELLER_STATUS,
  ACCOUNT_SELLER_STATUS_TEXT,
} from '../../../../../constants/service/app/accountSellerConstants';
import {
  STORE_ACTIVE_STATUS_SELECT_LIST,
  BRAND_REJECT_TYPE_TEXT,
} from '../../../../../constants/service/app/brandConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import './BrandDetailInfoStatus.scss';

const BrandDetailInfoStatus = (props) => {
  const { form, data, setData, isEditable } = props;
  const { status, confirmDate, createDate, rejectCnt, rejectType, rejectReason } = data;

  return (
    <Panel className="brand-detail-info-status">
      <div className="panel-header">
        <div className="title">판매점 입점상태</div>
      </div>

      <div className="panel-body">
        {
          /**
           *  판매점 상태가 활성화, 비활성화 인 경우에만 수정할 수 있도록 함
           */
          isEditable && (status === ACCOUNT_SELLER_STATUS.ACTIVE || status === ACCOUNT_SELLER_STATUS.INACTIVE) ? (
            <SelectForm
              label="판매점 상태"
              name="status"
              form={form}
              initialValue={status}
              list={STORE_ACTIVE_STATUS_SELECT_LIST}
              onChange={(value) => {
                setData({ path: ['brandDetail', 'info', 'statusInfo', 'status'], value });
              }}
            />
          ) : (
            <BaseForm label="판매점 상태" content={setDash(ACCOUNT_SELLER_STATUS_TEXT[status])} />
          )
        }

        {/* 입점 신청 일자 */}
        <BaseForm label="입점 신청 일자" content={setDateFormat(createDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)} />

        {/* 승인 처리 일자 */}
        <BaseForm label="승인 처리 일자" content={setDateFormat(confirmDate, DATE_FORMAT.YMD_HM_DASH_FORMAT)} />

        {rejectCnt ? (
          <Fragment>
            {/* 승인 거절 횟수 */}
            <BaseForm label="승인 거절 횟수" content={setDash(rejectCnt)} />

            {/* 승인 거절 타입 */}
            <BaseForm
              label="승인 거절 타입"
              content={rejectType.map((item) => setDash(BRAND_REJECT_TYPE_TEXT[item])).join(', ')}
            />

            {/* 거절 상세 이유 */}
            <BaseForm label="거절 상세 이유" content={setDash(rejectReason)} />
          </Fragment>
        ) : null}
      </div>
    </Panel>
  );
};

export default BrandDetailInfoStatus;
